var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPictoCompteEntreprise = function SvgPictoCompteEntreprise(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.712,
    height: 20.169,
    viewBox: "0 0 31.712 20.169",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "picto-compte_entreprise",
    transform: "translate(0.6 0.6)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1821"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2061"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_262",
    d: "M13.572,20.462H1.5V1.5H5.113V11.936l5.338-4.029a.43.43,0,0,1,.691.334l.04,3.993h.194l5.411-4.085a.632.632,0,0,1,1.014.491l.017,2.576",
    transform: "translate(-1.5 -1.5)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1823",
    transform: "translate(14.072 1.746)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2060",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_263",
    d: "M57.955,24.58a15.331,15.331,0,0,0-1.779-5.862,5.311,5.311,0,0,0-1.773-1.8c-1.775-1.1-7.533-.963-9.266,0a6.066,6.066,0,0,0-2.53,3.411,24.366,24.366,0,0,0-1.019,4.253ZM52.991,10.519A3.194,3.194,0,1,1,49.8,7.357,3.178,3.178,0,0,1,52.991,10.519Z",
    transform: "translate(-41.587 -7.357)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_290",
    y1: 4.388,
    transform: "translate(4.927 12.956)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_291",
    y1: 4.388,
    transform: "translate(11.406 12.956)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 1.2
  }))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPictoCompteEntreprise);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/picto-compte-entreprise.b37234b2543cf882d4afcc08ce572fd8.svg";